export default __webpack_public_path__ + "static/media/badge-android.1acff686.svg";